import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roleRequired, tierRequired }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  if (roleRequired && user.role !== roleRequired) {
    return <Navigate to="/403" replace />;
  }

  if (tierRequired && user.tier !== tierRequired) {
    return <Navigate to="/upgrade" replace />;
  }

  return children;
}
